import { useState } from 'react';
import { Chip, Stack } from '@mui/material';
import { LanguagesEditDialog } from './languages-edit-dialog';
import { LanguageLabels } from '@/constants/recommendation';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import { Language, Language as LanguageEnum } from '@/models/recommendation';
import { ProfileItem } from '@/packages/my-profile/components/profile-item';

export const Languages = () => {
  const { profile, updateProfile } = useRecommendationProfile();
  const [languagesEditDialogOpen, setLanguagesEditDialogOpen] = useState(false);

  const handleSave = (languages: Language[]) => {
    updateProfile({
      profile: {
        ...profile,
        languages: languages,
      },
    });
    setLanguagesEditDialogOpen(false);
  };

  const hasLanguages = profile?.languages && profile?.languages?.length > 0;

  return (
    <>
      <ProfileItem
        title="Idiomas"
        onClick={() => setLanguagesEditDialogOpen(true)}
      >
        {hasLanguages && (
          <Stack direction="row" gap={2} flexWrap="wrap">
            {profile?.languages?.map((language: LanguageEnum) => (
              <Chip key={language} label={LanguageLabels[language]} />
            ))}
          </Stack>
        )}
      </ProfileItem>
      {languagesEditDialogOpen && (
        <LanguagesEditDialog
          currentValues={profile?.languages ?? []}
          onClose={() => setLanguagesEditDialogOpen(false)}
          onSave={handleSave}
        />
      )}
    </>
  );
};
